import { AfterViewInit, Directive, ElementRef, Input, Optional, Self, SkipSelf } from '@angular/core';
import { generateUUID } from 'src/ep-utils';
import { FieldBlockComponent } from '../../../Views/Work/Accounts/proprietary/controls/form-controls/field-block/field-block.component';
import { FieldGroupComponent } from '../../../Views/Work/Accounts/proprietary/controls/form-controls/field-group/field-group.component';
import { FieldSectionComponent } from '../../../Views/Work/Accounts/proprietary/controls/form-controls/field-section/field-section.component';
import { FieldComponent } from '../../../Views/Work/Accounts/proprietary/controls/form-controls/field/field.component';
import { UXContainerComponent } from '../../../Views/Work/Accounts/proprietary/controls/form-controls/ux-container/ux-container.component';

@Directive({
    selector: '[uxdComponent], ep-field, ep-field-section, ep-field-block, ep-field-group, ep-ux-container',
    standalone: false
})
export class UXDesignerComponentDirective implements AfterViewInit {
    private _name: string = null;
    private _contentSelector: string = null;
    public element: ElementRef;

    @Input()
    set uxdName(name: string) {
        this._name = name;
        //this.IDAttribute = id;
    }

    get uxdName(): string {
        return this._name;
    }

    get parentUxdName(): string {
        if (this.parentUXComponent) {
            return this.parentUXComponent.uxdName;
        }
        return 'none';
    }

    get contentSelector(): string {
        return this._contentSelector;
    }

    constructor(
        private el: ElementRef,
        @Optional() @Self() private uxContainerComponent: UXContainerComponent,
        @Optional() @Self() private fieldComponent: FieldComponent,
        @Optional() @Self() private fieldSectionComponent: FieldSectionComponent,
        @Optional() @Self() private fieldBlockComponent: FieldBlockComponent,
        @Optional() @Self() private fieldGroupComponent: FieldGroupComponent,
        @Optional() @SkipSelf() private parentUXComponent: UXDesignerComponentDirective,
        @Optional() @SkipSelf() private parentUXContainerComponent: UXContainerComponent
    ) { }

    //TODO:  rewrite using custom injector token.    Have injector token have the following data property interface:
    //       contentSelection
    //       componentName?
    //       element?

    ngAfterViewInit() {
        if (this.uxContainerComponent) {
            this._name = 'root';
            this.element = this.uxContainerComponent.element;
            this._contentSelector = 'div.uxContainerContent';
            this.parentUXComponent = null; //don't cascade to a parent outside of current component
        }

        if (this.fieldSectionComponent) {
            if (!this._name || this._name == '') {
                let name = this.fieldSectionComponent.name;
                //HACK! f9d3ec9c-eac2-4e96-a484-7b3bae1f949e
                //Hack to auto name unnamed fields, blocks, sections, groups  until we add permanent names in code
                if (!name) {
                    name =
                        (this.parentUXContainerComponent
                            ? 'epfs_?' + this.parentUXContainerComponent.unnamedFieldSectionAutoNumber()
                            : null) || 'epfs_?' + generateUUID();
                    this.fieldSectionComponent.name = name;
                }
                //END HACK f9d3ec9c-eac2-4e96-a484-7b3bae1f949e
                this._name = name;
            }
            this.element = this.fieldSectionComponent.element;
            this._contentSelector = 'div.fieldSectionContent';
        }
        if (this.fieldGroupComponent) {
            if (!this._name || this._name == '') {
                let name = this.fieldGroupComponent.name;
                //HACK! f9d3ec9c-eac2-4e96-a484-7b3bae1f949e
                //Hack to auto name unnamed fields, blocks, sections, groups  until we add permanent names in code
                if (!name) {
                    name =
                        (this.parentUXContainerComponent
                            ? 'epfg_?' + this.parentUXContainerComponent.unnamedFieldGroupAutoNumber()
                            : null) || 'epfg_?' + generateUUID();
                    this.fieldGroupComponent.name = name;
                }
                //END HACK f9d3ec9c-eac2-4e96-a484-7b3bae1f949e
                this._name = name;
            }
            this.element = this.fieldGroupComponent.element;
            this._contentSelector = 'div.fieldGroupContent';
        }
        if (this.fieldBlockComponent) {
            if (!this._name || this._name == '') {
                let name = this.fieldBlockComponent.name;
                //HACK! f9d3ec9c-eac2-4e96-a484-7b3bae1f949e
                //Hack to auto name unnamed fields, blocks, sections, groups  until we add permanent names in code
                if (!name) {
                    name =
                        (this.parentUXContainerComponent
                            ? 'epfb_?' + this.parentUXContainerComponent.unnamedFieldBlockAutoNumber()
                            : null) || 'epfb_?' + generateUUID();
                    this.fieldBlockComponent.name = name;
                }
                //END HACK f9d3ec9c-eac2-4e96-a484-7b3bae1f949e
                this._name = name;
            }
            this.element = this.fieldBlockComponent.element;
            this._contentSelector = 'div.fieldBlockContent';
        }
        if (this.fieldComponent) {
            if (!this._name || this._name == '') {
                let name = this.fieldComponent.name;
                //HACK! f9d3ec9c-eac2-4e96-a484-7b3bae1f949e
                //Hack to auto name unnamed fields, blocks, sections, groups  until we add permanent names in code
                if (!name) {
                    name =
                        (this.parentUXContainerComponent
                            ? 'epf_?' + this.parentUXContainerComponent.unnamedFieldAutoNumber()
                            : null) || 'epf_?' + generateUUID();
                }
                //END HACK f9d3ec9c-eac2-4e96-a484-7b3bae1f949e
                this._name = name;
            }
            this.element = this.fieldComponent.element;
        }
    }
}
